'use strict';

var toastr = require('toastr');
var DataExtractService = function DataExtractService(restangular, $log) {
  var levelsService = restangular.one('extract').one('levels');
  var runService = restangular.service('run', restangular.one('extract'));
  var saveService = restangular.service('save', restangular.one('extract'));
  var scheduleService = restangular.service('schedule', restangular.one('extract'));
  var updateService = restangular.service('update', restangular.one('extract'));
  var rescheduleService = restangular.service('reschedule', restangular.one('extract'));
  function communicationErrorsHandler(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('DataExtractService: communicationErrorsHandler - ' + message);
    toastr.error(message);
  }
  function getLevels() {
    return levelsService.get();
  }
  function run(criteria) {
    return runService.post(criteria).then(function () {
      toastr.success('Run successfully.');
    }, communicationErrorsHandler);
  }
  function save(criteria) {
    return saveService.post(criteria).then(function () {
      toastr.success('Saved successfully.');
    }, communicationErrorsHandler);
  }
  function schedule(formData) {
    return scheduleService.post(formData).then(function () {
      toastr.success('Scheduled successfully.');
    }, communicationErrorsHandler);
  }
  function update(criteria) {
    return updateService.post(criteria).then(function () {
      toastr.success('Configuration updated successfully.');
    }, communicationErrorsHandler);
  }
  function reschedule(formData) {
    return rescheduleService.post(formData).then(function () {
      toastr.success('Configuration updated and rescheduled successfully.');
    }, communicationErrorsHandler);
  }
  return {
    getLevels: getLevels,
    run: run,
    save: save,
    schedule: schedule,
    update: update,
    reschedule: reschedule
  };
};
DataExtractService.$inject = ['Restangular', '$log'];
module.exports = DataExtractService;